export default function AuthLayout({ children }) {
  return (
    <div className="flex min-h-screen bg-background">
      <div className="mesh-dark grain relative hidden w-[46%] overflow-hidden lg:flex">
        <div className="pointer-events-none absolute -left-24 top-1/4 h-[420px] w-[420px] rounded-full bg-[#C4B5FD] opacity-40 blur-[120px]" />
        <div className="pointer-events-none absolute -right-16 bottom-10 h-[360px] w-[360px] rounded-full bg-[#B8A5FF] opacity-30 blur-[120px]" />
        <div className="relative z-10 flex w-full flex-col justify-between p-12 text-[#F9F9FB]">
          <div className="flex items-center justify-between">
            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#9CA3AF]">Mediana Magazine · Uso interno</div>
            <span className="rounded-full bg-[#C4B5FD] px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-[#0D0D0D]">v1.0</span>
          </div>
          <div>
            <div className="font-display text-[112px] leading-[0.85] tracking-tight">Mediana<br /><span className="text-[#C4B5FD]">Hub</span></div>
            <p className="mt-6 max-w-md text-[15px] leading-relaxed text-[#D1D5DB]">
              Hub de operaciones editoriales, comercial y administrativa de Mediana Magazine.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {[["Arte", "#A7F3D0"], ["Moda", "#FBCFE8"], ["Global", "#BAE6FD"], ["Pauta", "#FED7AA"], ["Libro Anual", "#FEF3C7"]].map(([t, c]) => (
                <span key={t} className="rounded-full px-2.5 py-0.5 text-[11px] font-medium text-[#0D0D0D]" style={{ background: c }}>{t}</span>
              ))}
            </div>
          </div>
          <div className="border-t border-[#262626] pt-5 font-mono text-[10.5px] uppercase tracking-wider text-[#9CA3AF]" data-testid="auth-footer-owner">
            Propiedad de EL MEDIO S.A.S. DE C.V.
          </div>
        </div>
      </div>
      <div className="flex flex-1 flex-col">
        <div className="flex h-14 items-center justify-between px-6 lg:hidden">
          <div className="font-display text-3xl">Mediana Hub</div>
          <div className="kicker">Uso interno</div>
        </div>
        <div className="flex flex-1 items-center justify-center px-4 py-10" data-testid="auth-container">
          {children}
        </div>
        <div className="px-6 pb-6 text-center font-mono text-[10.5px] uppercase tracking-wider text-muted-foreground">
          Acceso exclusivo para cuentas @medianamag.com
        </div>
      </div>
    </div>
  );
}
